import React from "react";
import "./Box.scss"
import {AiFillLinkedin} from 'react-icons/ai'

const Box = ({data}) =>{
    console.log("Box Data",data);
    data.Project.forEach(elem => {
        console.log("Elem",elem);
    });
  
    return(
        <div className="Box">
            <h1>{data.CollegeName}</h1>
            <div className="circles">
                <div className="circleContain">
                    <div className="circle"><h3>{data.PortfolioWebsites}</h3></div>
                    <p> Portfolio <br /> Websites</p>
                </div>
                <div className="circleContain">
                    <div className="circle"><h3>{data.TopProjects}</h3></div>
                    <p>MERN stack <br /> projects</p>
                </div>
                <div className="circleContain">
                    <div className="circle"><h3>{data.StudentTrained}</h3></div>
                    <p>Students <br /> Trained</p>
                </div>
                <div className="circleContain">
                    <div className="circle"><h3>{data.Days}</h3></div>
                    <p>Days</p>
                </div>
            </div>
            <h2>Top Projects</h2>
            <div className="projects">
                {
                    (data.Project).map((elem)=>         
                    <a className="project" href={elem.link.url}>
                        <img src={elem.image.filename} alt="1" />
                        <div className="team">
                                {

                                    
                                    <a className="mem" href={elem.LinkedinURL}>
                                            <p>{elem.name}</p>
                                            <AiFillLinkedin color="#053859" size={20}/>
                                    </a>
                                    
                                }
                        </div>
                    </a>
                    )
                }
            </div>
        </div>
    )
}

export default Box